import { Button, Select, useDisclosure } from "@chakra-ui/react";
import React, { FC, useContext } from "react";
import { useSearchParams } from "react-router";

import { RanaModal, TenantContext, useTenantListQuery } from "@nens/ranalib";
import { Organisation } from "@nens/threedi/openapi-client";

import HeaderBarButton from "../components/HeaderBarButton";
import { OrganisationContext } from "../providers/OrganisationProvider";

const SelectOrganisation: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { organisation, organisations, setOrganisation } = useContext(OrganisationContext);
  const tenantContext = useContext(TenantContext);
  const userId = tenantContext.isPublic ? "" : tenantContext.user.id;
  const tenantsQuery = useTenantListQuery(userId);
  const [searchParams] = useSearchParams();
  const disabled = !!searchParams.get("organisation");
  const tenantNames = new Map(
    (tenantsQuery.data?.items ?? []).map((tenant) => [tenant.id, tenant.name])
  );
  const tenantGroups = new Map<string, Organisation[]>();
  const hccOnlyOrganisations: Organisation[] = [];

  organisations.forEach((org) => {
    if (org.ranaTenantId) {
      const group = tenantGroups.get(org.ranaTenantId) ?? [];
      group.push(org);
      tenantGroups.set(org.ranaTenantId, group);
    } else {
      hccOnlyOrganisations.push(org);
    }
  });

  return (
    <>
      <HeaderBarButton
        icon="sort"
        onClick={onOpen}
        text={organisation?.name ?? "Select organisation"}
        disabled={disabled}
        title={disabled ? "Can't change organisation on detail page" : undefined}
      />
      <RanaModal
        isOpen={isOpen}
        onClose={onClose}
        topBar={"Select Organisation"}
        buttons={[
          <Button key="close" variant="primary" onClick={onClose}>
            Close
          </Button>,
        ]}
      >
        <Select
          variant="outline"
          value={organisation.uniqueId}
          onChange={(event) => {
            const uniqueId = event.target.value;
            const newOrg = organisations.find((org) => org.uniqueId === uniqueId);
            if (newOrg) {
              setOrganisation(newOrg);
              onClose();
            }
          }}
        >
          {[...tenantGroups.entries()].map(([tenantId, tenantOrganisations]) => (
            <optgroup key={tenantId} label={tenantNames.get(tenantId) ?? tenantId}>
              {tenantOrganisations.map((org) => (
                <option key={org.uniqueId} value={org.uniqueId}>
                  {org.name}
                </option>
              ))}
            </optgroup>
          ))}
          {hccOnlyOrganisations.length > 0 && (
            <optgroup label="HCC only">
              {hccOnlyOrganisations.map((org) => (
                <option key={org.uniqueId} value={org.uniqueId}>
                  {org.name}
                </option>
              ))}
            </optgroup>
          )}
        </Select>
      </RanaModal>
    </>
  );
};

export default SelectOrganisation;
